import axios from "axios";
import React, { useEffect, useState } from "react";
import Modal from "react-modal";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useNavigate, useParams } from "react-router-dom";
import { Button, Text } from "components";
import { useFormik } from "formik";
import * as Yup from "yup";
import Select from "react-select";

function CompanyLedgerEdit() {
  const [visible, setVisible] = useState(true);
  const [cmpanyLedgerType, setcmpanyLedgerType] = useState([]);
  let navigate = useNavigate();
  const { id } = useParams();
  const token = sessionStorage.getItem("token");
  const headers = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  const validationSchema = Yup.object().shape({
    name: Yup.string().required("Ledger Name is Required"),
    ledger_type_id: Yup.string().required("Please Select Ledger Type"),
    isactive: Yup.string().required("Please Select the Active"),
  });

  const formik = useFormik({
    initialValues: {
      id: id,
      name: "",
      ledger_type_id: "",
      isactive: "",
    },
    validationSchema: validationSchema,
    onSubmit: (values) => {
      handleFormSubmit(values);
    },
  });

  useEffect(() => {
    axios
      .post("/api/purple-fusion/companyledger/get", { id: id }, headers)
      .then((response) => {
        const newData = response.data[0];
        console.log(newData);
        formik.setValues((prevValues) => {
          return {
            ...prevValues,
            ...newData,
          };
        });
      })
      .catch((err) => {
        console.log(err);
      });
  }, [id]);

  useEffect(() => {
    getCompanyLedgerType();
  }, []);

  const getCompanyLedgerType = () => {
    axios
      .post("/api/purple-fusion/companyledger/ledgertype/get", {}, headers)
      .then((response) => {
        setcmpanyLedgerType(response.data);
      })
      .catch((error) => {
        console.error("Error fetching Company Data:", error);
      })
      .finally(() => {});
  };

  const handleFormSubmit = (values) => {
    console.log(values);

    axios
      .put("/api/purple-fusion/companyledger/update", values, headers)
      .then((response) => {
        console.log(response.data);
        const message = response.data.message;
        response.data.status
          ? toast.success(message, {
              autoClose: 1000,
              onClose: () => {
                setVisible(false);
                navigate(`/companysettingsall`);
              },
            })
          : toast.error(message, {
              autoClose: 1000,
            });
      })
      .catch((error) => {
        console.log(error);
        setVisible(false);
        navigate("*");
      });
  };

  const customStyles = {
    content: {
      width: "70%",
      height: "50%",
      margin: "auto",
      borderradius: "10px",
    },
    overlay: {
      backgroundColor: "rgba(0, 0, 0, 0.5)",
    },
  };

  return (
    <>
      <div>
        <Modal isOpen={visible} style={customStyles}>
          <form onSubmit={formik.handleSubmit}>
            <div className="flex flex-1 flex-col gap-[12px] justify-start md:px-5 w-full">
              <div className="flex flex-row w-[100%]">
                <div className="flex flex-row sm:gap-10 items-center justify-start w-full mt-0">
                  <Text
                    className="mt-[5px] md:text-xl sm:text-[24px] text-base text-black-900 tracking-[0.20px]"
                    size="txtInterMedium24"
                  >
                    Update Company Ledger
                  </Text>
                </div>

                <div className="flex flex-row items-center justify-end mt-0">
                  <Button
                    className="cursor-pointer font-medium mb-1.5 min-w-[70px] rounded-[7px] text-center text-lg tracking-[0.20px] active:scale-90 transition-transform duration-200"
                    shape="round"
                    color="blue_A700"
                    size="base"
                    variant="fill"
                    type="submit"
                  >
                    Save
                  </Button>
                  <Button
                    className="cursor-pointer font-medium mb-2 min-w-[70px] rounded-[7px] text-center text-xl tracking-[0.20px]"
                    shape="round"
                    color="white"
                    size="base"
                    variant="fill"
                    se
                    onClick={() => {
                      setVisible(false);
                      navigate(`/companysettingsall`);
                    }}
                  >
                    ╳
                  </Button>
                </div>
              </div>

              <div className="flex flex-col items-center justify-start md:ml-[0] ml-[25px] w-[87%] md:w-full mt-0">
                <ToastContainer />

                <div className="flex flex-col items-center justify-start  w-full">
                  <div className="md:gap-5 gap-x-8 gap-y-4 grid md:grid-cols-1 grid-cols-2 justify-center min-h-[auto] w-full mt-0">
                    <div className="flex flex-1 flex-col gap-1 items-start justify-start w-full mt-0">
                      <Text
                        className="md:text-[22px] text-black-700 text-center sm:text-xl tracking-[0.28px] w-auto"
                        size="txtInterMedium20Black900"
                      >
                        <span className="text-black-700 font-inter font-small text-sm">
                          Ledger Name
                        </span>
                        <span className="text-red-A700 font-inter font-small text-sm">
                          *
                        </span>
                      </Text>
                      <input
                        name="name"
                        type="text"
                        placeholder=" Enter Ledger Name"
                        value={formik.values.name}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        className="bg-white-A700 border border-gray-400_02 border-solid h-9 rounded-[5px] w-full text-xs"
                      />
                      {formik.touched.name && formik.errors.name ? (
                        <div className="text-red-500 text-sm">
                          {formik.errors.name}
                        </div>
                      ) : null}
                    </div>

                    <div className="flex flex-1 flex-col gap-1 items-start justify-start w-full mt-0">
                      <Text
                        className=" md:text-[22px] text-black-700 text-center sm:text-xl tracking-[0.28px] w-auto"
                        size="txtInterMedium20Black900"
                      >
                        <span className="text-black-700 font-inter font-small text-sm">
                          Select Ledger Type
                        </span>
                        <span className="text-red-A700 font-inter font-small text-sm">
                          *
                        </span>
                      </Text>

                      <Select
                        name="ledger_type_id"
                        options={cmpanyLedgerType
                          .filter((resstate) => resstate.isactive === true)
                          .map((resstate) => ({
                            label: resstate.name,
                            value: resstate.id,
                          }))}
                        className="bg-white-A700 border border-gray-200_02 border-solid h-9 rounded-[5px] w-full text-xs"
                        value={{
                          label: cmpanyLedgerType.find(
                            (option) =>
                              option.id === formik.values.ledger_type_id
                          )?.name,
                          value: formik.values.cmpanyLedgerType,
                        }}
                        onChange={(selectedOption) => {
                          formik.setFieldValue(
                            "ledger_type_id",
                            selectedOption.value
                          );
                        }}
                        onBlur={formik.handleBlur}
                        placeholder="Select workstation type"
                      />
                      {formik.touched.ledger_type_id &&
                      formik.errors.ledger_type_id ? (
                        <div className="text-red-500 text-sm">
                          {formik.errors.ledger_type_id}
                        </div>
                      ) : null}
                    </div>

                    <div className="flex flex-col gap-2 items-start justify-start w-full ">
                      <Text
                        className=" md:text-[22px] text-black-900 text-center sm:text-xl tracking-[0.28px] w-auto"
                        size="txtInterMedium20Black900"
                      >
                        <span className="text-black-700 font-inter font-small text-sm">
                          Active
                        </span>
                        <span className="text-red-A700 font-inter font-small text-sm">
                          *
                        </span>
                      </Text>
                      <form>
                        <div style={{ display: "flex" }}>
                          <label className="ml-1 mr-5 text-xs" htmlFor="yes">
                            <input
                              className="mr-2 text-xs"
                              type="radio"
                              id="yes"
                              name="isactive"
                              value="true"
                              checked={formik.values.isactive === true}
                              onChange={() => {
                                formik.handleChange({
                                  target: {
                                    name: "isactive",
                                    value: !formik.values.isactive, // Toggle the value
                                  },
                                });
                              }}
                            />
                            YES
                          </label>
                          <br />
                          <label className="ml-1 text-xs" htmlFor="no">
                            <input
                              className="mr-2 text-xs"
                              type="radio"
                              id="no"
                              name="isactive"
                              value="false"
                              checked={formik.values.isactive === false}
                              onChange={() => {
                                formik.handleChange({
                                  target: {
                                    name: "isactive",
                                    value: !formik.values.isactive, // Toggle the value
                                  },
                                });
                              }}
                            />
                            NO
                          </label>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </Modal>
      </div>
    </>
  );
}

export default CompanyLedgerEdit;
